import React from 'react';
import PropTypes from 'prop-types';
import SaveIcon from '@material-ui/icons/Save';
import {
  Button,
} from '@material-ui/core';

/**
 * This component allows to render a button specific to save actions.
 * @param {*} param0
 */
const ButtonSave = ({
  className, style, disabled, label = 'Guardar', onClick = null, ...rest
}) => (
  <Button
    className={className}
    style={style}
    variant="contained"
    type="submit"
    color="primary"
    disabled={disabled}
    startIcon={<SaveIcon />}
    onClick={onClick}
    {...rest}
  >
    {label}
  </Button>
);

ButtonSave.defaultProps = {
  className: '',
  style: {},
  disabled: false,
};

ButtonSave.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  style: PropTypes.shape(),
};

export default ButtonSave;
